/*@flow*/
import type { Node } from 'react';
import { OverlayTrigger } from 'react-bootstrap';
import React from 'react';

type PropsT = any;

export default (props: PropsT): any | Node => {
  if (props.disabled) return props.children;
  if (process.env.NODE_ENV === 'test') return props.children;

  return <OverlayTrigger {...props}>{props.children}</OverlayTrigger>;
};
